@if (display) {
  <div style="display: block;">
    <canvas baseChart
      [data]="barChartData"
      [options]="barChartOptions"
      [legend]="true"
      [type]="'bar'">
    </canvas>
  </div>
}
